import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    [
      _vm.product
        ? _c(
            "div",
            {
              staticClass:
                "d-flex text-subtitle-2 font-weight-light mb-4 justify-center",
            },
            [
              _c("div", [_vm._v(" " + _vm._s(_vm.product.name) + " ")]),
              _c(VDivider, { staticClass: "mx-2", attrs: { vertical: "" } }),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("formatNumber")(
                        _vm.balanceSummary ? _vm.balanceSummary.quantity : 0
                      )
                    ) +
                    " " +
                    _vm._s(_vm.product.measureWeight) +
                    " "
                ),
                _vm.product.reservedQuantity
                  ? _c("div", { staticClass: "text-caption" }, [
                      _c(
                        "a",
                        {
                          staticClass: "primary--text",
                          staticStyle: {
                            cursor: "pointer",
                            "text-decoration": "underline",
                          },
                          on: { click: _vm.openReservationDialog },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatNumber")(
                                  _vm.product.reservedQuantity
                                )
                              ) +
                              " " +
                              _vm._s(_vm.product.measureWeight) +
                              " (Reserved) "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(VDivider, { staticClass: "mx-2", attrs: { vertical: "" } }),
              _c("div", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("formatInteger")(
                        _vm.balanceSummary ? _vm.balanceSummary.count : 0
                      )
                    ) +
                    " Records "
                ),
              ]),
              _c(
                "div",
                { staticClass: "ml-2" },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  VIcon,
                                  _vm._g(
                                    {
                                      staticClass: "days-icon",
                                      on: {
                                        click: function ($event) {
                                          _vm.chartOptionDialogOpen = true
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [_vm._v("mdi-calendar-range")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2578760182
                      ),
                    },
                    [_c("span", [_vm._v("Change History Days")])]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.pendingOrderStatus
        ? _c(
            "div",
            [
              _c("span", { staticClass: "text-subtitle-2 font-weight-light" }, [
                _vm._v(" Outstanding Orders "),
              ]),
              _c(
                "div",
                { staticClass: "my-4", on: { click: _vm.viewOrderDetails } },
                [
                  _c(VProgressLinear, {
                    staticClass: "pointer",
                    attrs: {
                      value:
                        (_vm.pendingOrderStatus.totalFilledQuantity /
                          _vm.pendingOrderStatus.totalOrderQuantity) *
                        100,
                      color: "primary",
                      height: "25",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ value }) {
                            return [
                              _c("strong", [
                                _vm._v(_vm._s(Math.ceil(value)) + "%"),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3002676263
                    ),
                  }),
                  _c("div", { staticClass: "text-caption" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("formatNumber")(
                            _vm.pendingOrderStatus.totalFilledQuantity
                          )
                        ) +
                        " of " +
                        _vm._s(
                          _vm._f("formatNumber")(
                            _vm.pendingOrderStatus.totalOrderQuantity
                          )
                        ) +
                        " " +
                        _vm._s(_vm.product.measureWeight) +
                        " filled from " +
                        _vm._s(_vm.pendingOrderStatus.customers.length) +
                        " customers "
                    ),
                  ]),
                  _c(
                    VAlert,
                    {
                      staticClass: "ma-4",
                      attrs: {
                        "colored-border": "",
                        border: "left",
                        type: _vm.lowInventory ? "warning" : "success",
                      },
                    },
                    [
                      _vm.lowInventory
                        ? _c(
                            "div",
                            { staticClass: "font-weight-light" },
                            [
                              _c(
                                VIcon,
                                {
                                  staticClass: "my-auto mx-2",
                                  attrs: { color: "warning" },
                                },
                                [_vm._v(" mdi-alert ")]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$vuetify.lang.t(
                                      "$vuetify.dashboard.lowBalanceTitle"
                                    )
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatNumber")(
                              _vm.pendingOrderStatus.totalOrderQuantity -
                                _vm.pendingOrderStatus.totalFilledQuantity
                            )
                          ) +
                          " " +
                          _vm._s(_vm.product.measureWeight) +
                          " Delivery obligation / " +
                          _vm._s(
                            _vm._f("formatNumber")(
                              _vm.balanceSummary
                                ? _vm.balanceSummary.quantity
                                : 0
                            )
                          ) +
                          " " +
                          _vm._s(_vm.product.measureWeight) +
                          " Available "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex justify-space-between" },
                [_c(VSubheader, [_c("span", [_vm._v("Balance Summary")])])],
                1
              ),
              _c(VDivider, { staticClass: "my-4" }),
            ],
            1
          )
        : _vm._e(),
      _vm.balanceHistory
        ? _c(
            "div",
            [
              _c(
                VSheet,
                {
                  staticClass: "pa-3 d-flex justify-center",
                  attrs: { elevation: 2, height: 225 },
                },
                [
                  _c("line-chart", {
                    attrs: {
                      "show-legend": _vm.hasCostAndPrice ? true : false,
                      data: _vm.balanceHistory,
                      options: _vm.lineOptions,
                      height: 200,
                      width: "100%",
                      title: _vm.historyChartTitle,
                      responsive: true,
                      maintainAspectRatio: false,
                    },
                  }),
                ],
                1
              ),
              _c(
                VDialog,
                {
                  attrs: { "max-width": "400" },
                  model: {
                    value: _vm.chartOptionDialogOpen,
                    callback: function ($$v) {
                      _vm.chartOptionDialogOpen = $$v
                    },
                    expression: "chartOptionDialogOpen",
                  },
                },
                [
                  _c(
                    VCard,
                    [
                      _c(VCardTitle, [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v("Change History Days"),
                        ]),
                      ]),
                      _c(
                        VCardText,
                        [
                          _c(VTextField, {
                            attrs: { label: "Number of Days" },
                            model: {
                              value: _vm.historyDays,
                              callback: function ($$v) {
                                _vm.historyDays = $$v
                              },
                              expression: "historyDays",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCardActions,
                        [
                          _c(
                            VBtn,
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.chartOptionDialogOpen = false
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { color: "primary" },
                              on: { click: _vm.updateHistoryDays },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            [
              _c(VProgressLinear, { attrs: { indeterminate: "" } }),
              _c("span", { staticClass: "text-caption" }, [
                _vm._v("Loading balance history..."),
              ]),
            ],
            1
          ),
      _c(VDivider, { staticClass: "my-4" }),
      _c(
        VSheet,
        {
          staticClass: "pa-3 d-flex justify-center",
          attrs: { elevation: 2, height: 325 },
        },
        [
          _vm.locationData
            ? _c("bar-chart", {
                staticClass: "mb-6",
                attrs: {
                  "show-legend": false,
                  title: "Inventory by Locations",
                  data: _vm.locationData,
                  height: 300,
                  width: "80%",
                  responsive: true,
                  maintainAspectRatio: false,
                },
                on: { click: _vm.handleChartClick },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.selectedGroup
        ? _c(
            "div",
            { ref: "inventoryList" },
            [
              _c(VDivider, { staticClass: "my-6" }),
              _c(
                "div",
                { staticClass: "d-flex justify-space-between" },
                [
                  _c(VSubheader, [
                    _c("span", [
                      _vm._v(
                        "Found " +
                          _vm._s(
                            _vm.selectedGroup.inventories
                              ? _vm.selectedGroup.inventories.length
                              : 0
                          ) +
                          " records at location " +
                          _vm._s(_vm.selectedGroup.locationName)
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._l(
                _vm.selectedGroup.inventories,
                function (inventory, index) {
                  return _c(
                    VSheet,
                    {
                      directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                      key: inventory.id,
                      staticClass: "my-2 pa-2",
                      attrs: { elevation: 2 },
                      on: {
                        click: function ($event) {
                          return _vm.viewInventoryDetails(inventory)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex text-caption justify-space-between",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(index + 1) +
                                ". ID: " +
                                _vm._s(inventory.inventoryId) +
                                " "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.locationName(inventory.locationId)) +
                                " "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatDateYear")(
                                    inventory.stockedDate
                                  )
                                )
                            ),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "text-center text-h5 ma-6" }, [
                        _c("div", [
                          inventory.quantityRemaining <
                          inventory.originalQuantity
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        inventory.quantityRemaining -
                                          inventory.reservedQuantity
                                      )
                                    ) +
                                    " /  "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatNumber")(
                                  inventory.originalQuantity
                                )
                              ) +
                              " " +
                              _vm._s(_vm.product.measureWeight) +
                              " "
                          ),
                        ]),
                        _vm.product &&
                        _vm.product.children &&
                        _vm.product.children.length > 0
                          ? _c("div", { staticClass: "text-caption" }, [
                              _vm._v(" " + _vm._s(inventory.product) + " "),
                            ])
                          : _vm._e(),
                      ]),
                      inventory.reservedQuantity > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mb-4 d-flex justify-center font-weight-light text-caption",
                            },
                            [
                              _c(
                                VIcon,
                                {
                                  staticClass: "mr-1",
                                  attrs: { small: "", color: "warning" },
                                },
                                [_vm._v("mdi-lock")]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      inventory.reservedQuantity
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.product.measureWeight) +
                                  " Reserved "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "mb-4 d-flex justify-space-around" },
                        [
                          inventory.inputQuantityUsed
                            ? _c("div", [
                                _c("span", { staticClass: "mr-4" }, [
                                  _vm._v("Production"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        inventory.inputQuantityUsed
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.product.measureWeight)
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          inventory.adjustmentDeductionQuantity
                            ? _c("div", [
                                _c("span", { staticClass: "mr-4" }, [
                                  _vm._v("Adjustment"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        inventory.adjustmentDeductionQuantity
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.product.measureWeight)
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          inventory.quantitySold
                            ? _c("div", [
                                _c("span", { staticClass: "mr-4" }, [
                                  _vm._v("Sold"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        inventory.quantitySold
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.product.measureWeight)
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c("div", { staticClass: "text-caption text-left" }, [
                        _vm._v(
                          " Doc #: " + _vm._s(inventory.documentNumber) + " "
                        ),
                      ]),
                    ]
                  )
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _c(
        VBottomSheet,
        {
          attrs: { scrollable: "" },
          model: {
            value: _vm.showBottomSheet,
            callback: function ($$v) {
              _vm.showBottomSheet = $$v
            },
            expression: "showBottomSheet",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardActions,
                { staticClass: "justify-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mt-6",
                      attrs: { text: "" },
                      on: { click: _vm.hideBottomSheet },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.close")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _vm.showInventoryDetails
                    ? _c("inventory-details", {
                        key: _vm.selectedInventoryId,
                        on: { updatedLocation: _vm.updateLocation },
                        model: {
                          value: _vm.selectedInventoryId,
                          callback: function ($$v) {
                            _vm.selectedInventoryId = $$v
                          },
                          expression: "selectedInventoryId",
                        },
                      })
                    : _vm.showSalesOrders
                    ? _c(
                        "div",
                        [
                          _c(
                            VList,
                            [
                              _c(
                                VListItemGroup,
                                _vm._l(
                                  _vm.pendingOrderStatus.orders,
                                  function (order) {
                                    return _c(
                                      VListItem,
                                      {
                                        key: order.id,
                                        on: {
                                          click: function ($event) {
                                            return _vm.linkOrder(order)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          VListItemContent,
                                          [
                                            _c(VListItemTitle, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(order.customerName) +
                                                  " (" +
                                                  _vm._s(order.status) +
                                                  ") "
                                              ),
                                            ]),
                                            _c(VListItemSubtitle, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(order.salesOrderCode) +
                                                  " "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(VListItemActionText, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatDateYear")(
                                                  order.salesDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [_vm._v("No details")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "600", scrollable: "" },
          model: {
            value: _vm.showReservationDialog,
            callback: function ($$v) {
              _vm.showReservationDialog = $$v
            },
            expression: "showReservationDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "d-flex align-center" },
                [
                  _c(
                    VIcon,
                    { staticClass: "mr-2", attrs: { color: "warning" } },
                    [_vm._v("mdi-lock")]
                  ),
                  _c("span", [_vm._v("Inventory Reservations")]),
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.showReservationDialog = false
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(VDivider),
              _c(
                VCardText,
                { staticClass: "pt-4", staticStyle: { "max-height": "500px" } },
                [
                  _vm.loadingReservations
                    ? _c(
                        "div",
                        { staticClass: "text-center py-8" },
                        [
                          _c(VProgressCircular, {
                            attrs: { indeterminate: "", color: "primary" },
                          }),
                          _c("div", { staticClass: "text-caption mt-2" }, [
                            _vm._v("Loading reservations..."),
                          ]),
                        ],
                        1
                      )
                    : _vm.productReservations &&
                      _vm.productReservations.length > 0
                    ? _c(
                        "div",
                        [
                          _c(
                            VAlert,
                            {
                              staticClass: "mb-4",
                              attrs: { type: "info", dense: "", outlined: "" },
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      _vm.totalReservedQuantity
                                    )
                                  ) +
                                    " " +
                                    _vm._s(_vm.product.measureWeight)
                                ),
                              ]),
                              _vm._v(
                                " reserved across " +
                                  _vm._s(_vm.productReservations.length) +
                                  " worksheet(s) "
                              ),
                            ]
                          ),
                          _c(
                            VList,
                            { attrs: { "two-line": "" } },
                            _vm._l(
                              _vm.productReservations,
                              function (reservation, idx) {
                                return _c(
                                  VListItem,
                                  { key: idx, staticClass: "mb-2" },
                                  [
                                    _c(
                                      VListItemAvatar,
                                      { attrs: { color: "grey lighten-3" } },
                                      [
                                        _c(
                                          VIcon,
                                          { attrs: { color: "primary" } },
                                          [_vm._v("mdi-factory")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VListItemContent,
                                      [
                                        _c(
                                          VListItemTitle,
                                          { staticClass: "font-weight-medium" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  reservation.worksheetName
                                                ) +
                                                " - " +
                                                _vm._s(
                                                  reservation.processName
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(VListItemSubtitle, [
                                          _c(
                                            "div",
                                            { staticClass: "mt-1" },
                                            [
                                              _c(
                                                VChip,
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "primary",
                                                    label: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " WS #" +
                                                      _vm._s(
                                                        reservation.processWorksheetId
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                VChip,
                                                {
                                                  staticClass: "ml-2",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "success",
                                                    label: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          reservation.quantity
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.product
                                                          .measureWeight
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              reservation.inventoryUnitCode
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "ml-2 text-caption grey--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Unit: " +
                                                          _vm._s(
                                                            reservation.inventoryUnitCode
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-caption grey--text mt-1",
                                            },
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("mdi-clock-outline")]
                                              ),
                                              _vm._v(
                                                " Reserved: " +
                                                  _vm._s(
                                                    _vm._f("formatDateYear")(
                                                      reservation.createTime
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "text-center py-8 grey--text" },
                        [
                          _c(
                            VIcon,
                            { attrs: { large: "", color: "grey" } },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _c("div", { staticClass: "mt-2" }, [
                            _vm._v("No reservations found"),
                          ]),
                        ],
                        1
                      ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }